import React from 'react';

import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import theme from 'constants/theme';

const Wrapper = styled.div`
  background: ${(props) => props.theme.palette.background.lightBlue40};
  height: 92vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const NotEnabled = () => (
  <Wrapper>
    <StyledTypography weight={600} style={{ fontSize: '20px' }} color={theme.palette.text.heading}>
      Feature not enabled for your organization!
    </StyledTypography>

    <StyledTypography color={theme.palette.grey.dark} variant="caption" topGutter={2} bottomGutter={5}>
      Please contact your organization admin to get this feature enabled
    </StyledTypography>
  </Wrapper>
);

export default NotEnabled;
